import { SetWorkbookDataModel } from "../Models/Excel/SetWorkbookDataModel";

export class ExcelFormatDataService {
    public static getExcelFormatInfo(excelFormatId: string, callback: (output: any) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/excelformat/${excelFormatId}/info`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}